import dynamic from "next/dynamic";
import Auth0Callback from "./Callbacks/Auth0Callback";
import CognitoCallback from "./Callbacks/CognitoCallback";
import type Props from "./Props";
import SocialAuthLogin from "./SocialAuthLogin";

const SocialAuth: FC<Props> = ({ module }) => {
  switch (module) {
    case "auth0Callback":
      return <Auth0Callback />;
    case "cognitoCallback":
      return <CognitoCallback />;
    case "login":
      return <SocialAuthLogin />;
    default:
      return <div />;
  }
};

export default SocialAuth;
